














import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppSectionGridItem from '@/components/AppSectionGridItem.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { Item } from '@/mixins'

@Component({
  components: {
    AppSectionGridItem,
    AppTitleBar
  },
  apollo: {
    coupon: {
      query: gql`query couponAtCouponItems($couponId: ID!) {
        coupon(couponId: $couponId) {
          id
          items {
            ...ItemTileFragment
          }
        }
      }
      ${ITEM_TILE_FRAGMENT}`,
      variables () {
        return {
          couponId: this.$route.params.id
        }
      }
    }
  }
})
export default class extends Mixins(Item) {
  coupon = { items: [] }

  async onClickLikeItem ({ id, isLiked }: { id: string; isLiked: boolean }) {
    await this.toggleLikeItem(id, isLiked)
  }
}
